import React, { useState, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';

const libraries = ['places'];

function GoogleMapsAutocomplete({
                                    label = "Select Location",
                                    value = [],
                                    onPlaceSelected,
                                    readOnly = false,
                                    errorText = "",
                                    isValid = true,
                                    multiple = true
                                }) {
    const [inputValue, setInputValue] = useState("");
    const [selectedLocations, setSelectedLocations] = useState(value);
    const [options, setOptions] = useState(["Remote"]);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyAia_hK6K6w8rYqk2ev98MkZbNQ7yQSpec',
        libraries,
    });

    useEffect(() => {
        if (JSON.stringify(value) !== JSON.stringify(selectedLocations)) {
            setSelectedLocations(value);
        }
    }, [value, selectedLocations]);

    useEffect(() => {
        if (inputValue && isLoaded) {
            const service = new window.google.maps.places.AutocompleteService();

            service.getPlacePredictions({ input: inputValue, types: ['(cities)'] }, (predictions) => {
                if (predictions) {
                    const formattedOptions = predictions.map(prediction =>
                        prediction.description.replace(/, /, " (") + ")"
                    );
                    setOptions(["Remote", ...formattedOptions]);
                }
            });
        } else {
            setOptions(["Remote"]);
        }
    }, [inputValue, isLoaded]);

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
    };

    const handleChange = (event, newValue) => {
        setSelectedLocations(newValue);
        onPlaceSelected(newValue);
    };

    return isLoaded ? (
        <div>
            <Autocomplete
                multiple={multiple}
                id="google-maps-autocomplete"
                options={options}
                freeSolo
                value={selectedLocations}
                onChange={handleChange}
                onInputChange={handleInputChange}
                sx={readOnly ? { pointerEvents: 'none' } : {}}
                renderInput={(params) => (
                    <TextField
                        data-testid="mapsText"
                        {...params}
                        label={label}
                        variant={readOnly ? "standard" : "outlined"}
                        fullWidth
                        error={!isValid}
                    />
                )}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => {
                        const tagProps = getTagProps({ index });
                        return (
                            <Chip
                                key={index}
                                label={option}
                                {...(readOnly ? {} : { onDelete: tagProps.onDelete })}
                                disabled={false}
                                style={{ margin: 2 }}
                            />
                        );
                    })
                }
            />
            {!isValid && errorText && (
                <FormHelperText error>{errorText}</FormHelperText>
            )}
        </div>
    ) : (
        <p>Loading...</p>
    );
}

export default GoogleMapsAutocomplete;